import React from 'react';
import { BaseText, theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import { isWeb } from 'utils/deviceUtils';
import { useAttachmentRow } from './useAttachmentRow';

type AttachmentTableRowProps = {
  noBorder?: boolean;
  withTopBorder?: boolean;
};

const AttachmentTableRow: React.FC<AttachmentTableRowProps> = ({
  noBorder = false,
  withTopBorder = false,
}) => {
  const { title, displayName, isInteractive, handlePress } = useAttachmentRow();

  // Web has no working attachment flow: no picker modal and no preview route.
  if (isWeb) return null;

  return (
    <MenuItem
      testID="selected-attachment"
      iconName="Document-Filled"
      menuLabel={title}
      rightComponent={
        <BaseText
          color={theme.colors.gray300}
          numberOfLines={1}
          testID="selected-attachment-name">
          {displayName}
        </BaseText>
      }
      noBorder={noBorder}
      borderTopWidth={withTopBorder ? 3 : 0}
      onPress={isInteractive ? handlePress : undefined}
    />
  );
};

export default AttachmentTableRow;
